// Sai Maheshwar 01/12/2022 2701306337 ,2701326866  added search component

import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import SaveAlert from '../../../components/DialogBox/SaveAlert';
import SearchIntermediateRepo from './SearchIntermediateRepo';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function BreTabs({value, setValue}) {
  const classes = useStyles();
  const [tabValue, setTabValue] = React.useState(0);
  const [open, setOpen] = useState(false);

  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {open && (
          <SaveAlert
            title="Skip Schedule"
            value={`Are you sure to proceed without saving schedule ?`}
            setTabValue={setTabValue}
            setOpen={setOpen}
            open={open}
            tabvalue={tabValue}
          />
        )}
        {tabValue === 0 && <SearchIntermediateRepo />}
        {/* {tabValue === 1 && (
          <AddNightJobs
            selected={selected}
            setTabValue={setTabValue}
            tabValue={tabValue}
            handleTabChange={handleTabChange}
          />
        )} */}
      </div>
    </div>
  );
}
